interface PolicyState {
    isPolicyAccepted: boolean | null;
    errorMessage: string;
    loading?: boolean;
    regionCode: string;
    language: string;
    fileUrl: string;
    checkPolicyAccepted: boolean;
}

interface PolicyAction {
    type: string;
    payload?: any;
}

const defaultState: PolicyState = {
    isPolicyAccepted: null,
    checkPolicyAccepted: false,
    errorMessage: "",
    loading: false,
    regionCode: "Global",
    language: "EN",
    fileUrl: "",
}

const policyReducer = (state: PolicyState = defaultState, action: PolicyAction): PolicyState => {
    switch (action.type) {
        case 'GET_POLICY_STARTED':
            return { ...state, loading: true };
        case 'GET_POLICY_COMPLETED': 
            return {...state, 
                loading: false,
                ...action.payload,
            }
        case 'GET_POLICY_ERROR':
            return { ...state, loading: false, errorMessage: action.payload };
        case 'RESET_POLICY_ERROR':
            return { ...state, errorMessage: ""};
        case 'ACCEPT_POLICY_STARTED':
            return { ...state, loading: true };
        case 'ACCEPT_POLICY_COMPLETED':
            return { ...state, loading: false, ...action.payload };
        case 'ACCEPT_POLICY_ERROR':
            return { ...state, loading: false, errorMessage: action.payload };
        default:
            return state;
    }
}

export default policyReducer;